module.exports = {
	"job": {
		"lang": "en",
		"user_id": 46548,
		"name": "yoga_vibe.mp3",
		"duration": 185,
		"created_at": "Fri Jul 27 20:11:42 2018",
		"id": 8856513
	},
	"speakers": [
		{
			"duration": "57.29",
			"confidence": null,
			"name": "M2",
			"time": "1.75"
		},
		{
			"duration": "5.46",
			"confidence": null,
			"name": "M3",
			"time": "59.31"
		},
		{
			"duration": "43.36",
			"confidence": null,
			"name": "M2",
			"time": "64.87"
		},
		{
			"duration": "11.63",
			"confidence": null,
			"name": "M3",
			"time": "108.28"
		},
		{
			"duration": "19.62",
			"confidence": null,
			"name": "M2",
			"time": "120.01"
		},
		{
			"duration": "4.80",
			"confidence": null,
			"name": "M3",
			"time": "140.41"
		},
		{
			"duration": "34.41",
			"confidence": null,
			"name": "F2",
			"time": "145.72"
		},
		{
			"duration": "3.05",
			"confidence": null,
			"name": "M2",
			"time": "181.90"
		}
	],
	"words": [
		{
			"duration": "0.90",
			"confidence": "1.000",
			"name": "Hey",
			"time": "1.75"
		},
		{
			"duration": "0.77",
			"confidence": "0.970",
			"name": "everybody",
			"time": "2.69"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "how's",
			"time": "3.49"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "it",
			"time": "3.70"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "going",
			"time": "3.76"
		},
		{
			"duration": "0.03",
			"confidence": "1.000",
			"name": ".",
			"time": "4.45"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "Happy",
			"time": "4.48"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "Saturday",
			"time": "4.93"
		},
		{
			"duration": "0.17",
			"confidence": "1.000",
			"name": "to",
			"time": "5.47"
		},
		{
			"duration": "0.28",
			"confidence": "0.940",
			"name": "you",
			"time": "5.64"
		},
		{
			"duration": "0.14",
			"confidence": "0.950",
			"name": "it's",
			"time": "5.92"
		},
		{
			"duration": "0.33",
			"confidence": "0.720",
			"name": "Maria",
			"time": "6.07"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "Triano",
			"time": "6.40"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "from",
			"time": "7.09"
		},
		{
			"duration": "0.16",
			"confidence": "0.870",
			"name": "a",
			"time": "7.68"
		},
		{
			"duration": "0.30",
			"confidence": "0.970",
			"name": "dance",
			"time": "7.84"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "network",
			"time": "8.14"
		},
		{
			"duration": "0.03",
			"confidence": "0.620",
			"name": ".",
			"time": "8.58"
		},
		{
			"duration": "0.19",
			"confidence": "0.930",
			"name": "And",
			"time": "8.61"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "happy",
			"time": "8.80"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "healthy",
			"time": "9.16"
		},
		{
			"duration": "0.18",
			"confidence": "0.540",
			"name": "whole",
			"time": "9.44"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "essential",
			"time": "9.64"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "oils",
			"time": "10.06"
		},
		{
			"duration": "0.51",
			"confidence": "0.940",
			"name": ".",
			"time": "10.63"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "I",
			"time": "11.17"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "hope",
			"time": "11.29"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "you",
			"time": "11.47"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "guys",
			"time": "11.53"
		},
		{
			"duration": "0.06",
			"confidence": "0.890",
			"name": "are",
			"time": "11.71"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "having",
			"time": "11.77"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "12.04"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "really",
			"time": "12.10"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "nice",
			"time": "12.31"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "weekend",
			"time": "12.58"
		},
		{
			"duration": "0.09",
			"confidence": "0.990",
			"name": ".",
			"time": "14.10"
		},
		{
			"duration": "0.20",
			"confidence": "0.850",
			"name": "I",
			"time": "14.19"
		},
		{
			"duration": "0.22",
			"confidence": "0.850",
			"name": "am",
			"time": "14.40"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "here",
			"time": "14.62"
		},
		{
			"duration": "0.18",
			"confidence": "0.990",
			"name": "in",
			"time": "15.19"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "my",
			"time": "15.37"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "backyard",
			"time": "15.49"
		},
		{
			"duration": "0.35",
			"confidence": "0.960",
			"name": "bringing",
			"time": "16.90"
		},
		{
			"duration": "0.29",
			"confidence": "0.790",
			"name": "to",
			"time": "17.29"
		},
		{
			"duration": "0.57",
			"confidence": "0.520",
			"name": "live",
			"time": "17.65"
		},
		{
			"duration": "0.39",
			"confidence": "0.990",
			"name": "our",
			"time": "18.25"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "daily",
			"time": "18.67"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "diary",
			"time": "19.03"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "for",
			"time": "19.57"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "the",
			"time": "19.72"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "month",
			"time": "19.84"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "of",
			"time": "20.38"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "June",
			"time": "20.53"
		},
		{
			"duration": "0.09",
			"confidence": "0.970",
			"name": ".",
			"time": "21.01"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "I",
			"time": "21.10"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "wanted",
			"time": "21.22"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "to",
			"time": "21.52"
		},
		{
			"duration": "0.29",
			"confidence": "1.000",
			"name": "share",
			"time": "21.70"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "with",
			"time": "22.00"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "you",
			"time": "22.24"
		},
		{
			"duration": "0.47",
			"confidence": "1.000",
			"name": "how",
			"time": "22.49"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "I",
			"time": "22.96"
		},
		{
			"duration": "0.29",
			"confidence": "0.720",
			"name": "use",
			"time": "23.08"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "oils",
			"time": "23.50"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "on",
			"time": "24.49"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "24.64"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "daily",
			"time": "24.70"
		},
		{
			"duration": "0.72",
			"confidence": "1.000",
			"name": "basis",
			"time": "25.03"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "to",
			"time": "26.05"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "get",
			"time": "26.20"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "me",
			"time": "26.41"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "through",
			"time": "26.56"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "all",
			"time": "27.07"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "of",
			"time": "27.37"
		},
		{
			"duration": "0.57",
			"confidence": "0.990",
			"name": "life's",
			"time": "27.52"
		},
		{
			"duration": "0.75",
			"confidence": "1.000",
			"name": "joyful",
			"time": "28.96"
		},
		{
			"duration": "0.72",
			"confidence": "1.000",
			"name": "challenges",
			"time": "29.80"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "and",
			"time": "30.61"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "difficult",
			"time": "31.15"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "challenges",
			"time": "31.63"
		},
		{
			"duration": "0.37",
			"confidence": "1.000",
			"name": "and",
			"time": "33.25"
		},
		{
			"duration": "0.19",
			"confidence": "0.740",
			"name": "just",
			"time": "33.62"
		},
		{
			"duration": "0.18",
			"confidence": "0.820",
			"name": "to",
			"time": "33.89"
		},
		{
			"duration": "0.49",
			"confidence": "0.960",
			"name": "really",
			"time": "34.09"
		},
		{
			"duration": "0.41",
			"confidence": "0.980",
			"name": "explain",
			"time": "34.93"
		},
		{
			"duration": "0.28",
			"confidence": "1.000",
			"name": "to",
			"time": "35.35"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "35.80"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "little",
			"time": "35.86"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "bit",
			"time": "36.07"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "about",
			"time": "36.25"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "how",
			"time": "36.55"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "you",
			"time": "36.76"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "can",
			"time": "36.88"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "use",
			"time": "37.06"
		},
		{
			"duration": "0.15",
			"confidence": "0.980",
			"name": "the",
			"time": "37.24"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "oils",
			"time": "37.39"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "in",
			"time": "37.81"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "your",
			"time": "37.96"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "everyday",
			"time": "38.17"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "life",
			"time": "38.65"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "to",
			"time": "40.18"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "assist",
			"time": "40.48"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "you",
			"time": "40.90"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "with",
			"time": "41.56"
		},
		{
			"duration": "0.04",
			"confidence": "0.670",
			"name": "the",
			"time": "41.99"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "things",
			"time": "42.07"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "that",
			"time": "42.37"
		},
		{
			"duration": "0.14",
			"confidence": "0.940",
			"name": "you're",
			"time": "42.49"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "going",
			"time": "42.64"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "through",
			"time": "42.97"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "your",
			"time": "44.02"
		},
		{
			"duration": "0.81",
			"confidence": "1.000",
			"name": "emotions",
			"time": "44.17"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "your",
			"time": "45.04"
		},
		{
			"duration": "0.84",
			"confidence": "1.000",
			"name": "physical",
			"time": "45.91"
		},
		{
			"duration": "0.78",
			"confidence": "1.000",
			"name": "concerns",
			"time": "46.90"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "your",
			"time": "47.68"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "any",
			"time": "49.48"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "of",
			"time": "49.72"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "your",
			"time": "49.81"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "spiritual",
			"time": "49.93"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "things",
			"time": "50.47"
		},
		{
			"duration": "0.09",
			"confidence": "0.980",
			"name": "and",
			"time": "51.25"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "just",
			"time": "51.34"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "sort",
			"time": "51.52"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "of",
			"time": "51.70"
		},
		{
			"duration": "0.54",
			"confidence": "0.960",
			"name": "explain",
			"time": "51.79"
		},
		{
			"duration": "0.32",
			"confidence": "1.000",
			"name": "to",
			"time": "52.33"
		},
		{
			"duration": "0.24",
			"confidence": "0.650",
			"name": "you",
			"time": "52.65"
		},
		{
			"duration": "0.11",
			"confidence": "0.700",
			"name": "and",
			"time": "52.89"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "give",
			"time": "53.05"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "you",
			"time": "53.26"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "just",
			"time": "53.41"
		},
		{
			"duration": "0.20",
			"confidence": "0.940",
			"name": "some",
			"time": "53.69"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "little",
			"time": "53.89"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "daily",
			"time": "54.79"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "diary",
			"time": "55.09"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "tips",
			"time": "55.57"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "on",
			"time": "56.02"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "how",
			"time": "56.23"
		},
		{
			"duration": "0.21",
			"confidence": "0.990",
			"name": "I",
			"time": "57.25"
		},
		{
			"duration": "0.27",
			"confidence": "0.990",
			"name": "use",
			"time": "57.46"
		},
		{
			"duration": "0.12",
			"confidence": "0.970",
			"name": "the",
			"time": "57.73"
		},
		{
			"duration": "0.42",
			"confidence": "0.960",
			"name": "oils",
			"time": "57.85"
		},
		{
			"duration": "0.58",
			"confidence": "0.790",
			"name": "everyday",
			"time": "58.34"
		},
		{
			"duration": "0.12",
			"confidence": "0.590",
			"name": ".",
			"time": "58.92"
		},
		{
			"duration": "0.38",
			"confidence": "0.770",
			"name": "Okay",
			"time": "59.31"
		},
		{
			"duration": "0.03",
			"confidence": "0.680",
			"name": ".",
			"time": "59.80"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "And",
			"time": "59.92"
		},
		{
			"duration": "0.33",
			"confidence": "0.410",
			"name": "everything",
			"time": "60.97"
		},
		{
			"duration": "0.11",
			"confidence": "0.950",
			"name": "is",
			"time": "61.31"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "going",
			"time": "61.42"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "to",
			"time": "61.54"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "be",
			"time": "61.60"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "different",
			"time": "61.69"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "because",
			"time": "62.11"
		},
		{
			"duration": "0.15",
			"confidence": "0.990",
			"name": "as",
			"time": "62.68"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "we",
			"time": "62.83"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "know",
			"time": "62.92"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "each",
			"time": "63.16"
		},
		{
			"duration": "0.35",
			"confidence": "1.000",
			"name": "moment",
			"time": "63.37"
		},
		{
			"duration": "0.15",
			"confidence": "0.850",
			"name": "is",
			"time": "63.73"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "different",
			"time": "63.88"
		},
		{
			"duration": "0.44",
			"confidence": "0.820",
			"name": ".",
			"time": "64.33"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "Today",
			"time": "64.87"
		},
		{
			"duration": "0.17",
			"confidence": "0.800",
			"name": "I",
			"time": "65.46"
		},
		{
			"duration": "0.25",
			"confidence": "0.800",
			"name": "am",
			"time": "65.64"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "breathing",
			"time": "65.89"
		},
		{
			"duration": "0.12",
			"confidence": "0.990",
			"name": "and",
			"time": "66.37"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "taking",
			"time": "66.49"
		},
		{
			"duration": "0.59",
			"confidence": "0.760",
			"name": "five",
			"time": "66.91"
		},
		{
			"duration": "0.20",
			"confidence": "0.550",
			"name": "out",
			"time": "68.35"
		},
		{
			"duration": "0.37",
			"confidence": "1.000",
			"name": "here",
			"time": "68.58"
		},
		{
			"duration": "0.12",
			"confidence": "0.680",
			"name": "I'm",
			"time": "68.97"
		},
		{
			"duration": "0.18",
			"confidence": "0.970",
			"name": "in",
			"time": "69.19"
		},
		{
			"duration": "0.43",
			"confidence": "0.990",
			"name": "my",
			"time": "69.42"
		},
		{
			"duration": "0.31",
			"confidence": "1.000",
			"name": "yoga",
			"time": "70.36"
		},
		{
			"duration": "0.18",
			"confidence": "0.890",
			"name": "that",
			"time": "71.17"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "my",
			"time": "71.38"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "husband",
			"time": "71.53"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "built",
			"time": "71.86"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "me",
			"time": "72.10"
		},
		{
			"duration": "0.33",
			"confidence": "0.500",
			"name": "and",
			"time": "72.56"
		},
		{
			"duration": "0.18",
			"confidence": "0.450",
			"name": "two",
			"time": "73.17"
		},
		{
			"duration": "0.35",
			"confidence": "0.840",
			"name": "fans",
			"time": "73.44"
		},
		{
			"duration": "0.08",
			"confidence": "0.950",
			"name": "are",
			"time": "73.79"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "back",
			"time": "73.87"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "here",
			"time": "74.14"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "you",
			"time": "74.29"
		},
		{
			"duration": "0.24",
			"confidence": "0.990",
			"name": "might",
			"time": "74.38"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "hear",
			"time": "74.62"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "some",
			"time": "74.83"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "frogs",
			"time": "75.07"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "singing",
			"time": "76.51"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "to",
			"time": "76.93"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "us",
			"time": "77.17"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "which",
			"time": "77.65"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "is",
			"time": "77.86"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "really",
			"time": "78.04"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "awesome",
			"time": "78.43"
		},
		{
			"duration": "0.14",
			"confidence": "0.950",
			"name": ".",
			"time": "79.80"
		},
		{
			"duration": "0.14",
			"confidence": "0.960",
			"name": "And",
			"time": "79.94"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "you",
			"time": "80.08"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "also",
			"time": "80.14"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "might",
			"time": "80.38"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "hear",
			"time": "80.53"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "some",
			"time": "80.68"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "traffic",
			"time": "80.83"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "going",
			"time": "81.19"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "by",
			"time": "81.43"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "because",
			"time": "81.64"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "we",
			"time": "81.88"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "live",
			"time": "82.00"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "on",
			"time": "83.17"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "83.32"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "side",
			"time": "83.38"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "road",
			"time": "83.71"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "but",
			"time": "83.98"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "it",
			"time": "84.31"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "does",
			"time": "84.40"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "get",
			"time": "84.64"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "84.79"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "little",
			"time": "84.85"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "noisy",
			"time": "85.09"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "from",
			"time": "85.48"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "time",
			"time": "85.63"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "to",
			"time": "85.90"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "time",
			"time": "85.99"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "but",
			"time": "86.77"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I'm",
			"time": "86.95"
		},
		{
			"duration": "0.25",
			"confidence": "1.000",
			"name": "back",
			"time": "87.04"
		},
		{
			"duration": "0.10",
			"confidence": "0.600",
			"name": "here",
			"time": "87.29"
		},
		{
			"duration": "0.06",
			"confidence": "0.770",
			"name": "in",
			"time": "87.43"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "my",
			"time": "87.49"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "little",
			"time": "87.64"
		},
		{
			"duration": "0.81",
			"confidence": "1.000",
			"name": "sanctuary",
			"time": "87.88"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "where",
			"time": "88.69"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "88.84"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "teach",
			"time": "88.93"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "89.17"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "lot",
			"time": "89.23"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "of",
			"time": "89.56"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "my",
			"time": "89.68"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "yoga",
			"time": "90.37"
		},
		{
			"duration": "0.60",
			"confidence": "0.990",
			"name": "retreats",
			"time": "90.76"
		},
		{
			"duration": "0.15",
			"confidence": "0.880",
			"name": "my",
			"time": "91.36"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "yoga",
			"time": "91.51"
		},
		{
			"duration": "0.75",
			"confidence": "1.000",
			"name": "classes",
			"time": "91.78"
		},
		{
			"duration": "0.18",
			"confidence": "0.970",
			"name": "my",
			"time": "93.23"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "different",
			"time": "93.43"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "Reiki",
			"time": "93.76"
		},
		{
			"duration": "0.51",
			"confidence": "0.980",
			"name": "retreats",
			"time": "94.81"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "meditation",
			"time": "95.32"
		},
		{
			"duration": "0.66",
			"confidence": "1.000",
			"name": "courses",
			"time": "95.92"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "all",
			"time": "97.42"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "kinds",
			"time": "97.57"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "of",
			"time": "97.81"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "stuff",
			"time": "97.87"
		},
		{
			"duration": "0.02",
			"confidence": "0.770",
			"name": ".",
			"time": "98.17"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "So",
			"time": "98.20"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "I'm",
			"time": "98.44"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "back",
			"time": "98.56"
		},
		{
			"duration": "0.36",
			"confidence": "0.990",
			"name": "here",
			"time": "98.83"
		},
		{
			"duration": "0.30",
			"confidence": "0.750",
			"name": ".",
			"time": "99.19"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "This",
			"time": "99.58"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "is",
			"time": "99.79"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "my",
			"time": "99.94"
		},
		{
			"duration": "0.30",
			"confidence": "0.980",
			"name": "zen",
			"time": "100.15"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "space",
			"time": "100.45"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "where",
			"time": "100.81"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "100.93"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "go",
			"time": "101.02"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "to",
			"time": "101.74"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "just",
			"time": "101.89"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "reconnect",
			"time": "102.10"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "with",
			"time": "102.70"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "nature",
			"time": "102.85"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "which",
			"time": "103.27"
		},
		{
			"duration": "0.12",
			"confidence": "0.980",
			"name": "is",
			"time": "103.51"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "really",
			"time": "103.63"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "the",
			"time": "104.05"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "topic",
			"time": "104.23"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "about",
			"time": "104.71"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "what",
			"time": "106.27"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "106.45"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "wanted",
			"time": "106.54"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "to",
			"time": "106.75"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "share",
			"time": "106.84"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "with",
			"time": "107.05"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "you",
			"time": "107.26"
		},
		{
			"duration": "0.76",
			"confidence": "0.940",
			"name": ".",
			"time": "107.47"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "108.28"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "just",
			"time": "108.37"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "finished",
			"time": "108.64"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "doing",
			"time": "109.36"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "some",
			"time": "109.72"
		},
		{
			"duration": "0.42",
			"confidence": "0.990",
			"name": "office",
			"time": "109.99"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "work",
			"time": "110.41"
		},
		{
			"duration": "0.09",
			"confidence": "0.980",
			"name": ".",
			"time": "110.74"
		},
		{
			"duration": "0.27",
			"confidence": "0.980",
			"name": "It's",
			"time": "110.83"
		},
		{
			"duration": "0.09",
			"confidence": "0.980",
			"name": "a",
			"time": "111.19"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "hot",
			"time": "111.28"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "humid",
			"time": "111.61"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "day",
			"time": "111.91"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "here",
			"time": "112.21"
		},
		{
			"duration": "0.09",
			"confidence": "0.980",
			"name": "in",
			"time": "112.39"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "the",
			"time": "112.48"
		},
		{
			"duration": "0.66",
			"confidence": "1.000",
			"name": "Poconos",
			"time": "112.57"
		},
		{
			"duration": "0.23",
			"confidence": "0.510",
			"name": ".",
			"time": "113.23"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "And",
			"time": "113.68"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "nature",
			"time": "114.94"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "is",
			"time": "115.39"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "115.57"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "really",
			"time": "115.63"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "good",
			"time": "115.96"
		},
		{
			"duration": "0.30",
			"confidence": "0.990",
			"name": "way",
			"time": "116.17"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "to",
			"time": "116.47"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "cleanse",
			"time": "116.77"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "and",
			"time": "117.16"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "clear",
			"time": "117.28"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "your",
			"time": "117.64"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "energy",
			"time": "117.85"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "to",
			"time": "118.39"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "help",
			"time": "118.54"
		},
		{
			"duration": "0.12",
			"confidence": "0.950",
			"name": "you",
			"time": "118.78"
		},
		{
			"duration": "0.13",
			"confidence": "0.830",
			"name": "go",
			"time": "118.90"
		},
		{
			"duration": "0.52",
			"confidence": "0.810",
			"name": "around",
			"time": "119.02"
		},
		{
			"duration": "0.37",
			"confidence": "0.760",
			"name": ".",
			"time": "119.54"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "And",
			"time": "120.01"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "again",
			"time": "120.19"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "these",
			"time": "120.76"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "little",
			"time": "121.30"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "videos",
			"time": "121.78"
		},
		{
			"duration": "0.15",
			"confidence": "0.990",
			"name": "I'm",
			"time": "122.26"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "doing",
			"time": "122.41"
		},
		{
			"duration": "0.18",
			"confidence": "0.990",
			"name": "are",
			"time": "122.77"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "teaching",
			"time": "122.95"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "you",
			"time": "123.37"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "ways",
			"time": "123.46"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "to",
			"time": "123.88"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "take",
			"time": "124.03"
		},
		{
			"duration": "0.60",
			"confidence": "0.680",
			"name": "five",
			"time": "124.36"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "and",
			"time": "124.96"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "breathe",
			"time": "125.14"
		},
		{
			"duration": "0.31",
			"confidence": "0.560",
			"name": "instead",
			"time": "125.98"
		},
		{
			"duration": "0.09",
			"confidence": "0.530",
			"name": "of",
			"time": "126.29"
		},
		{
			"duration": "0.22",
			"confidence": "1.000",
			"name": "just",
			"time": "126.45"
		},
		{
			"duration": "0.28",
			"confidence": "0.750",
			"name": "going",
			"time": "126.90"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "through",
			"time": "127.18"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "everything",
			"time": "127.39"
		},
		{
			"duration": "0.54",
			"confidence": "0.690",
			"name": ".",
			"time": "127.96"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "We",
			"time": "128.50"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "really",
			"time": "128.74"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "need",
			"time": "129.07"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "these",
			"time": "129.34"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "little",
			"time": "129.58"
		},
		{
			"duration": "0.57",
			"confidence": "0.980",
			"name": "resets",
			"time": "129.94"
		},
		{
			"duration": "0.09",
			"confidence": "0.990",
			"name": "and",
			"time": "130.51"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "little",
			"time": "130.60"
		},
		{
			"duration": "0.54",
			"confidence": "0.990",
			"name": "reboots",
			"time": "130.84"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "as",
			"time": "131.38"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "we",
			"time": "131.56"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "go",
			"time": "131.74"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "on",
			"time": "131.98"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "throughout",
			"time": "132.64"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "each",
			"time": "133.54"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "of",
			"time": "133.87"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "our",
			"time": "134.14"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "lovely",
			"time": "134.89"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "lives",
			"time": "135.22"
		},
		{
			"duration": "0.03",
			"confidence": "0.990",
			"name": ".",
			"time": "136.18"
		},
		{
			"duration": "0.06",
			"confidence": "0.990",
			"name": "It",
			"time": "136.80"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "really",
			"time": "136.87"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "helps",
			"time": "137.20"
		},
		{
			"duration": "0.25",
			"confidence": "1.000",
			"name": "to",
			"time": "137.62"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "clear",
			"time": "138.01"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "your",
			"time": "138.88"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "mind",
			"time": "139.03"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "139.63"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "And",
			"time": "140.41"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "to",
			"time": "140.71"
		},
		{
			"duration": "0.21",
			"confidence": "0.980",
			"name": "just",
			"time": "140.83"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "step",
			"time": "141.13"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "forward",
			"time": "141.43"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "in",
			"time": "142.03"
		},
		{
			"duration": "0.03",
			"confidence": "1.000",
			"name": "a",
			"time": "142.21"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "fresh",
			"time": "142.24"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "new",
			"time": "142.60"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "beginning",
			"time": "142.75"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "which",
			"time": "143.14"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "we",
			"time": "143.35"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "really",
			"time": "143.53"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "can",
			"time": "143.86"
		},
		{
			"duration": "0.42",
			"confidence": "0.970",
			"name": "choose",
			"time": "144.04"
		},
		{
			"duration": "0.15",
			"confidence": "0.990",
			"name": "in",
			"time": "144.46"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "every",
			"time": "144.61"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "moment",
			"time": "144.88"
		},
		{
			"duration": "0.03",
			"confidence": "0.920",
			"name": ".",
			"time": "145.18"
		},
		{
			"duration": "0.66",
			"confidence": "1.000",
			"name": "So",
			"time": "145.72"
		},
		{
			"duration": "0.27",
			"confidence": "0.990",
			"name": "here's",
			"time": "146.77"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "where",
			"time": "147.04"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "I",
			"time": "147.25"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "am",
			"time": "147.46"
		},
		{
			"duration": "0.48",
			"confidence": "0.990",
			"name": "today",
			"time": "147.70"
		},
		{
			"duration": "0.33",
			"confidence": "0.640",
			"name": ".",
			"time": "148.18"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "I",
			"time": "148.69"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "am",
			"time": "148.93"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "in",
			"time": "149.11"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "need",
			"time": "149.23"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "of",
			"time": "149.65"
		},
		{
			"duration": "0.71",
			"confidence": "1.000",
			"name": "definitely",
			"time": "149.98"
		},
		{
			"duration": "0.98",
			"confidence": "0.850",
			"name": "peppermint",
			"time": "151.09"
		},
		{
			"duration": "0.77",
			"confidence": "0.730",
			"name": ".",
			"time": "152.08"
		},
		{
			"duration": "0.35",
			"confidence": "0.940",
			"name": "There's",
			"time": "153.10"
		},
		{
			"duration": "0.08",
			"confidence": "0.870",
			"name": "the",
			"time": "153.46"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "peppermint",
			"time": "153.55"
		},
		{
			"duration": "0.62",
			"confidence": "0.530",
			"name": ".",
			"time": "154.06"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "I'm",
			"time": "154.90"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "in",
			"time": "155.11"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "need",
			"time": "155.23"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "of",
			"time": "155.44"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "some",
			"time": "155.50"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "peppermint",
			"time": "155.68"
		},
		{
			"duration": "0.09",
			"confidence": "0.950",
			"name": ".",
			"time": "156.19"
		},
		{
			"duration": "0.54",
			"confidence": "0.990",
			"name": "Why",
			"time": "156.28"
		},
		{
			"duration": "0.06",
			"confidence": "0.920",
			"name": ".",
			"time": "156.82"
		},
		{
			"duration": "0.75",
			"confidence": "1.000",
			"name": "Because",
			"time": "156.88"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "it",
			"time": "157.69"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "is",
			"time": "158.02"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "humid",
			"time": "158.74"
		},
		{
			"duration": "0.18",
			"confidence": "0.890",
			"name": "and",
			"time": "159.76"
		},
		{
			"duration": "0.13",
			"confidence": "0.930",
			"name": "it's",
			"time": "159.96"
		},
		{
			"duration": "0.56",
			"confidence": "1.000",
			"name": "sticky",
			"time": "160.09"
		},
		{
			"duration": "0.24",
			"confidence": "0.990",
			"name": "and",
			"time": "161.14"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "when",
			"time": "161.38"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "you",
			"time": "161.56"
		},
		{
			"duration": "0.35",
			"confidence": "0.910",
			"name": "place",
			"time": "161.68"
		},
		{
			"duration": "0.37",
			"confidence": "1.000",
			"name": "some",
			"time": "162.03"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "drops",
			"time": "162.40"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "of",
			"time": "162.79"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "peppermint",
			"time": "162.91"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "on",
			"time": "163.48"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "the",
			"time": "164.38"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "back",
			"time": "164.47"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "of",
			"time": "164.74"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "your",
			"time": "164.86"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "neck",
			"time": "165.01"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "165.4"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "You",
			"time": "167.80"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "will",
			"time": "168.04"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "feel",
			"time": "168.28"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "168.79"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "Just",
			"time": "169.75"
		},
		{
			"duration": "0.87",
			"confidence": "1.000",
			"name": "sensational",
			"time": "170.05"
		},
		{
			"duration": "0.12",
			"confidence": "0.800",
			"name": "and",
			"time": "170.97"
		},
		{
			"duration": "0.12",
			"confidence": "0.780",
			"name": "up",
			"time": "171.17"
		},
		{
			"duration": "0.18",
			"confidence": "0.450",
			"name": "two",
			"time": "171.34"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "seconds",
			"time": "171.52"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "your",
			"time": "172.96"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "whole",
			"time": "173.14"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "body",
			"time": "173.35"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "will",
			"time": "173.74"
		},
		{
			"duration": "0.39",
			"confidence": "0.610",
			"name": "fall",
			"time": "173.95"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "down",
			"time": "174.34"
		},
		{
			"duration": "0.72",
			"confidence": "1.000",
			"name": "and",
			"time": "175.36"
		},
		{
			"duration": "0.24",
			"confidence": "0.970",
			"name": "you'll",
			"time": "176.68"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "be",
			"time": "176.92"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "able",
			"time": "177.10"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "to",
			"time": "177.40"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "just",
			"time": "177.58"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "feel",
			"time": "177.88"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "like",
			"time": "178.69"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "this",
			"time": "178.93"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "warm",
			"time": "179.44"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "180.13"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "Cooling",
			"time": "181.90"
		},
		{
			"duration": "0.72",
			"confidence": "1.000",
			"name": "effect",
			"time": "182.41"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "on",
			"time": "183.37"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "the",
			"time": "183.64"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "skin",
			"time": "183.76"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "and",
			"time": "184.36"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "it",
			"time": "184.51"
		},
		{
			"duration": "0.17",
			"confidence": "0.930",
			"name": "it",
			"time": "184.78"
		},
		{
			"duration": "0.00",
			"confidence": "1.000",
			"name": ".",
			"time": "184.95"
		}
	],
	"format": "1.0"
};


//////////////////
// WEBPACK FOOTER
// ./src/yoga_vibe.json
// module id = 33
// module chunks = 0